import { type IHostProps } from '@wix/native-components-infra/dist/es/src/types/types';
import React from 'react';

type Host = IHostProps;

export const HostContext = React.createContext<Host | undefined>(undefined);

type HostProviderProps = {
  children: React.ReactNode;
  host: IHostProps;
};

export const HostProvider = React.memo(
  ({ children, host }: HostProviderProps) => {
    return <HostContext.Provider value={host}>{children}</HostContext.Provider>;
  },
);

export function useHost() {
  const context = React.useContext(HostContext);
  if (context === undefined) {
    throw new Error('useHost must be used within a HostProvider');
  }
  return context;
}
